import ReactDOM from 'react-dom';

class NavTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.listItem = React.createRef();
    this.listItemEl = null;
  }

  state = {
    hovered: false,
  };

  componentDidMount() {
    this.listItemEl = ReactDOM.findDOMNode(this.listItem.current);
  }

  onMouseEnter() {
    this.setState({ hovered: true });
  }

  onMouseLeave() {
    this.setState({ hovered: false });
  }

  getListItemTop(offset = 10) {
    if (this.listItemEl) {
      return this.listItemEl.getBoundingClientRect().y + offset;
    }
  }

  render() {
    const {
      props,
      onMouseEnter,
      onMouseLeave,
      getListItemTop,
      listItem,
    } = this;
    const { hovered } = this.state;

    return props.render({
      hovered: hovered,
      onMouseEnter: onMouseEnter.bind(this),
      onMouseLeave: onMouseLeave.bind(this),
      getListItemTop: getListItemTop.bind(this),
      parentRef: listItem,
    });
  }
}

NavTooltip.propTypes = {
  render: PropTypes.func.isRequired,
};

export default NavTooltip;
